import React from "react";

import CustomTooltip from "../CustomTooltip/CustomTooltip";

const UnEnrollConfirmModal = ({
  isOpen,
  onClose,
  UnEnrollMethod
}) => {
  if (!isOpen) return null;
  return (
    <div className="location-modal-overlay">
      <div className="in_person-content">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            style={{ fontSize: "22px", fontWeight: "700", marginLeft: "10px" }}
          >
          Confirm Unenroll
          </div>
          <CustomTooltip text="Close" placement="top">
            <button className="btn-close" onClick={onClose}></button>
          </CustomTooltip>
        </div>

        <div className="in_person_modal_data">
          <div className="in_person_modal_details">
            <div className="in_person_modal_subheading">
             Are you sure you want to unenroll this session?
            </div>
           
          </div>
        </div>

       
        <div className="in_person_modal_actions">
          <button
            className="secondary_button"
            style={{ width: "120px" }}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="button"
            style={{ width: "120px" }}
            onClick={() => {onClose();
                UnEnrollMethod();}}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnEnrollConfirmModal;
